import { render, staticRenderFns } from "./FreeItemDeal.vue?vue&type=template&id=5ddcca3b&scoped=true&"
import script from "./FreeItemDeal.vue?vue&type=script&lang=js&"
export * from "./FreeItemDeal.vue?vue&type=script&lang=js&"
import style0 from "./FreeItemDeal.vue?vue&type=style&index=0&id=5ddcca3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddcca3b",
  null
  
)

export default component.exports